import {z} from 'zod'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {useFormContext, useWatch} from 'react-hook-form'
import {AgendaEventFormGenericFields} from '@/features/agenda/components/agenda-event-form/agenda-event-form-generic-fields/AgendaEventFormGenericFields'
import {AgendaEventFormSingleFields} from '@/features/agenda/components/agenda-event-form/agenda-event-form-single/AgendaEventFormSingleFields'
import {AgendaEventFormTeamFields} from '@/features/agenda/components/agenda-event-form/agenda-event-form-team-fields/AgendaEventFormTeamFields'
import {AgendaEventTypeSelector} from '@/features/agenda/components/agenda-event-form/agenda-event-type-selector/AgendaEventTypeSelector'
import {ExternalStructureEventFields} from '@/features/agenda/components/external-structure-event-fields/ExternalStructureEventFields'

const AgendaEventFormFieldsSchema = AgendaEventFieldsSchema.pick({
    category: true,
    date: true,
    isGenericEvent: true
})
type AgendaEventFormFieldsSchema = z.infer<typeof AgendaEventFormFieldsSchema>

export const AgendaEventFormFields = ({
    mode,
    defaultDate,
    isExternalStructure
}: {
    mode?: 'create' | 'edit'
    defaultDate?: Date
    isExternalStructure?: boolean
}) => {
    const {control} = useFormContext<AgendaEventFormFieldsSchema>()
    const category = useWatch({control, name: 'category'})
    const isGenericEvent = useWatch({control, name: 'isGenericEvent'})

    // External structure events are ordinary events with a reduced form: no type selector, since the
    // category follows the selected access type
    if (isExternalStructure) {
        return <ExternalStructureEventFields />
    }

    return (
        <>
            <AgendaEventTypeSelector mode={mode} />
            {isGenericEvent ? (
                <AgendaEventFormGenericFields />
            ) : category == 'team_meeting' ? (
                <AgendaEventFormTeamFields />
            ) : (
                <AgendaEventFormSingleFields mode={mode} defaultDate={defaultDate} />
            )}
        </>
    )
}
